module.exports = __webpack_public_path__ + "static/media/udemy.b9ec5aff.png";